<template>
    <div class="myData_container">
        <div style="display: flex; justify-content: right;">
            <van-popover id="myDataPop" v-model:show="showPopover" :actions="options">
                <template #reference>
                    <div class="selectorContainer">
                        <van-row class="selectorBox">
                            <van-col span="21">{{ $t(tabList[active].name) }}</van-col>
                            <van-col span="3"><van-icon name="arrow-down" color="#fff" /></van-col>
                        </van-row>
                    </div>
                </template>
                <template #default>
                    <div class="option_card">
                        <div class="option_row" v-for="item in options" :key="item.text"
                            :style="{ background: selectAction.id == item.id ? 'rgb(0, 86, 85)' : 'rgb(0, 53, 52)' }"
                            @click="onSelect(item)">
                            {{ $t(item.text) }}</div>
                    </div>
                </template>
            </van-popover>
        </div>

        <!-- <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="setTab()">
            <van-tab v-for="(item, index) in tabList" :key="index" :title="$t(item.name)" :name="index"> -->
                <div class="content">
                    <div class="timeRange_card">
                        <img src="@/assets/agent/yuce_bai.png" alt="">
                        {{ formatUnixTimestamp(myData.start_time) + " - " + formatUnixTimestamp(myData.end_time) }}
                    </div>
                    <TotalCard :title1="$t('myDataView.directCommision')" :title2="$t('myDataView.teamCommission')"
                        :title3="$t('myDataView.totalCommssion')" rightText1="R$"
                        :value1="formatCurrency(myData.user_data.direct_commission)"
                        :value2="formatCurrency(myData.user_data.team_commission)"
                        :value3="formatCurrency(myData.user_data.total_commission)" />
                    <TotalCard :title1="$t('myDataView.bets')" :title2="$t('myDataView.teamBets')"
                        :title3="$t('myDataView.totalBets')" rightText1="R$"
                        :value1="formatCurrency(myData.user_data.direct_bet)"
                        :value2="formatCurrency(myData.user_data.team_bet)"
                        :value3="formatCurrency(myData.user_data.total_bet)" />
                    <TotalCard :title1="$t('myDataView.recharge')" :title2="$t('myDataView.teamRecharge')"
                        :title3="$t('myDataView.totalRecharge')" rightText1="R$"
                        :value1="formatCurrency(myData.user_data.direct_recharge)"
                        :value2="formatCurrency(myData.user_data.team_recharge)"
                        :value3="formatCurrency(myData.user_data.total_recharge)" />
                    <TotalCard :title1="$t('myDataView.registration')" :title2="$t('myDataView.teamRegistration')"
                        :title3="$t('myDataView.totalRecords')" :rightText2="$t('common.pepole')"
                        :value1="myData.user_data.new_direct_user_count" :value2="myData.user_data.new_team_user_count"
                        :value3="myData.user_data.new_user_count" />
                    <TotalCard :title1="$t('myDataView.firstDirectCommission')"
                        :title2="$t('myDataView.teamsFirstDeposit')" :rightText2="$t('common.pepole')"
                        :title3="$t('myDataView.totalInitialDepost')"
                        :value1="myData.user_data.new_direct_first_recharge_count"
                        :value2="myData.user_data.new_team_first_recharge_count"
                        :value3="myData.user_data.new_first_recharge_count" />
                </div>
            <!-- </van-tab>
        </van-tabs> -->
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
        <LoadingScreen ref="loadingRef" />
    </div>
</template>

<script setup lang="ts">
import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { onMounted, ref } from 'vue';
import TotalCard from './totalCard.vue';
import { useI18n } from 'vue-i18n';
import { getMyData } from '@/api/agent';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { MY_DATA_TAB_LIST, getMyDataListFunc, UserData, MyDataItem, MY_DATA_OPTIONS } from '@/view/agent/supportScript';
const { t } = useI18n();
const myData = ref<MyDataItem>({
    start_time: 0,
    end_time: 0,
    user_data: {
        direct_commission: 0,
        total_commission: 0,
        direct_bet: 0,
        total_bet: 0,
        new_direct_user_count: 0,
        new_user_count: 0,
        direct_recharge: 0,
        total_recharge: 0,
        new_direct_first_recharge_count: 0,
        new_first_recharge_count: 0,
        team_commission: 0,
        team_bet: 0,
        team_recharge: 0,
        new_team_user_count: 0,
        new_team_first_recharge_count: 0
    }
});
const active = ref(0)
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const tabList = ref(MY_DATA_TAB_LIST)
const options = ref(MY_DATA_OPTIONS)
const showPopover = ref(false)
const selectAction = ref<any>(options.value[0])

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getMyDataList = () => {
    getMyDataListFunc(getMyData, active, myData, loadingRef, showError)
}

const setTab = () => {
    loadingRef.value.open()
    getMyDataList();
    console.log('active----', active.value);


}

const onSelect = (action: any) => {
    active.value = action.id
    selectAction.value = action
    showPopover.value = false
    loadingRef.value.open()
    getMyDataList();
    console.log('action----', action);
};
onMounted(() => {
    loadingRef.value.open()
    getMyDataList()
})

</script>
<style scoped>
.myData_container {
    padding: 15px;
    background: rgb(2, 74, 73);
    border-radius: 10px;
    margin: 15px;
}

.myData_container>>>.van-tabs__nav {
    background: transparent;
    padding: 0;
}

.myData_container>>>.van-tab {
    color: rgba(255, 255, 255, 0.527);
    font-weight: 200;
    font-size: 14px;
    margin: 0 5px;
    padding: 10px;
    height: 40px;
}

.myData_container>>>.van-tab:hover {
    background-color: #ffffff13;
}

.myData_container>>>.van-tab.van-tab--active {
    color: #fff;
    font-weight: bold;
}

.myData_container>>>.van-tabs__line {
    background-color: #1989fa;
    height: 2px;
    bottom: 5px;
}

.timeRange_card {
    padding: 15px;
    font-weight: 400;
    color: rgba(255, 255, 255);
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 5px 0;
    background: rgb(0, 53, 52);
    border-radius: 10px;
    font-weight: 500;
}

.timeRange_card img {
    width: 20px;
    opacity: 0.45;
    margin: 0 10px;
}

.selectorContainer {
    padding: 15px;
    display: flex;
    justify-content: right;
}

.selectorBox {
    color: #ffffff4c;
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid rgb(0, 97, 95);
    background: rgb(0, 86, 85);
    font-weight: 400px;
    min-width: 130px;
}

.option_card {
    color: #ffffff4a;
}

.option_row {
    padding: 10px;
}

#myDataPop :deep(.van-popover__content) {
    background: transparent !important;
    border: 1px solid #000 !important;
    box-shadow: none !important;
}

#myDataPop :deep(.van-popover__arrow) {
    color: rgb(0, 53, 52) !important;
}
</style>